import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import api from '../../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import Loader from '../../../components/loading';
import { formatPriceBR } from '../../../util';
import PaginationComponent from '../../../components/paginacao';
import '../../../style/proposta.css';

const Proposta = () => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pedidos, setPedidos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const BASE_URL = process.env.REACT_APP_BASE_URL
    const [selectedVenda, setSelectedVenda] = useState(null);
    //Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotalPage] = useState(1);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const STATUS_MAP = {
        1: "Pendente",
        2: "Aprovado",
        3: "Cancelado",
        4: "Retirada",
        5: "Entregue",
    };
    const getStatusLabel = (value) => STATUS_MAP[value] || "Desconhecido";
    // Função para buscar as propostas da API
    const fetchPedidosUser = async (page = 1) => {
        try {
            setLoading(true);
            const response = await api.get(`pedidos-user?page=${page}`);
            const { orders } = response.data;

            // Salva as propostas e as informações de paginação no estado
            setPedidos(orders);
            //Paginacao
            const itemsPerPage = 10
            const totalPages = Math.ceil(orders.total / itemsPerPage);
            setTotalPage(totalPages)
            setCurrentPage(orders.current_page)
            setLoading(false);
        } catch (error) {
            console.log(error, 'error')
            setError('Erro ao carregar as propostas.');
            setLoading(false);
        }
    };

    // UseEffect para buscar as propostas ao montar o componente
    useEffect(() => {
        fetchPedidosUser();
    }, []);

    // Função para exibir detalhes da proposta selecionada
    const handleViewDetails = (venda) => {
        console.log(venda, 'venda')
        setSelectedVenda(venda);
        setShowModal(true); // Abre o modal
    };

    return (
        <Container>
            <h2 className='text-center mb-4 titulo-pagina'><i style={{ color: '#ff7a00' }} class="fa-solid fa-cart-shopping mr-3"></i> Pedidos de Vendas</h2>
            {success && (
                <Alert className="text-center " variant="success">
                    {success}
                    <Button className="m-3" variant="close" onClick={() => setSuccess(null)}></Button>
                </Alert>
            )}
            {error && (
                <Alert className="text-center " variant="danger">
                    {error}
                    <Button className="m-3" variant="close" onClick={() => setError(null)}></Button>
                </Alert>
            )}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={currentPage}
                    lastPage={total}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                {pedidos && pedidos.data && pedidos.data.length > 0 ? (
                    <h5 style={{ color: '#333', fontWeight: '700' }}>{pedidos?.data[0]?.user?.name}</h5>
                ) : (
                    <p>Nenhum pedido disponível...</p>
                )}
                <Table hover responsive className='text-center tabela-painel mt-4' style={{ fontSize: '0.7em' }}>
                    <thead className='cabecalho-tabela'>
                        <tr>
                            <th>N° pedido</th>
                            <th>Data do Pedido</th>
                            <th>Status</th>
                            <th>Forma de Pagamento</th>
                            <th>Total</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pedidos?.data?.length > 0 ? (
                            pedidos?.data?.map((venda, index) => (
                                <tr key={venda.id} className='celula-tabela'>
                                    <td>{venda.id}</td>
                                    <td>{new Date(venda.created_at).toLocaleDateString()}</td>
                                    <td>{getStatusLabel(venda.payment?.status)}</td>
                                    <td>{venda.payment?.payment_method || 'N/A'}</td>
                                    <td>{formatPriceBR(venda?.total_price)}</td>
                                    <td>
                                        <div className='table-actions'>
                                            <Button
                                                variant="info"
                                                size="sm"
                                                className="botao-acao me-2"
                                                onClick={() => handleViewDetails(venda)}
                                            >
                                                Visualizar
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    Nenhum pedido encontrado.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Detalhes do Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedVenda && (
                        <div>
                            <div className='shadow-lg bg-white rounded' style={{ borderLeft: '5px solid rgb(243, 165, 44)', borderRadius: '10px', padding: '20px', width: '100%' }}>
                                <p><strong>Status: </strong>{getStatusLabel(selectedVenda.payment?.status)} </p>
                                <p><strong>Forma de Pagamento:</strong> {selectedVenda.payment?.payment_method}</p>
                                <p><strong>Total:</strong> R$ {!isNaN(Number(selectedVenda.total_price)) ? Number(selectedVenda.total_price).toFixed(2) : 'valor inválido'}</p>
                                <h5>Produtos:</h5>
                                {selectedVenda?.order_items?.map((item) => (
                                    <Row>
                                        <Col lg={6} md={6} xs={12} className='d-flex justify-content-center align-items-center'>
                                            <img
                                                variant="top"
                                                src={
                                                    item?.product?.images[0]?.url
                                                        ? item?.product?.images[0]?.url.startsWith("data:image") // Verifica se é base64
                                                            ? item?.product?.images[0]?.url // Base64
                                                            : `${BASE_URL}storage/${item?.product?.images[0]?.url}` // Caminho no servidor
                                                        : "default-image-path" // Caminho para uma imagem padrão
                                                }
                                                alt="Produto"
                                                style={{ maxWidth: '120px', objectFit: 'contain' }}
                                            />
                                        </Col>
                                        <Col lg={6} md={6} xs={12} className='text-center'>
                                            <p>{item.product.name}</p>
                                            <p>{item.quantity} x R$ {Number(item.unit_price).toFixed(2)} = R$ {Number(item.total_price).toFixed(2)}</p>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </Container >
    );
};

export default Proposta;
